module.exports = __webpack_public_path__ + "static/media/star.6012206e.svg";